import "sumo/js/protocol";
import Details from "protocol/js/details";


export function collapsibleAccordionInit() {
  'use strict';
  // Initialize any header elements, or header elements wrapped by a "div.for"
  // element (which is generated from the Wiki syntax "{for ...}{/for}") that
  // are direct children of an element with the "mzp-c-details" class.
  for (let hdr of ['h2', 'h3', 'h4', 'h5', 'h6']) {
    Details.init(`.mzp-c-details > ${hdr}, .mzp-c-details > div.for > ${hdr}`);
  }
}

export default function detailsInit() {
  'use strict';
  var _mqWide = matchMedia('(max-width: 1055px)');

  var sidebarList = document.querySelector('.details-heading');

  function swapMobileSubnavText(){
    var button = document.querySelector('.details-heading button');
    var activeLink = document.querySelector('.sidebar-nav .selected a') ||
      document.querySelector('.sidebar-nav a.selected') ||
      document.querySelector('.sidebar-nav .sidebar-subheading');

    if (activeLink) {
      var mobileButtonText = activeLink.innerHTML;
    } else {
      var mobileButtonText = 'Sidebar';
    }

    button.innerHTML = mobileButtonText;
  }

  function initializeMobileDetails() {
    Details.init('.details-heading');
    if (document.body.classList.contains('document')
      && (document.querySelector('#doc-tools')?.textContent ?? "").trim() === "") {
      // The only potential section of a mobile article sidebar is empty, so there's no sense in displaying the sidebar.
      // This isn't relevant for the large version, where the sidebar will always include the helpfulness survey at least.
      // Note that we can't check #aside directly, since the helpfulness survey has not been moved from it yet.
      let aside = document.querySelector('#aside');
      if (aside) {
        aside.hidden = true;
      }
    }
    else {
      swapMobileSubnavText();
    }
  }

  if (sidebarList && _mqWide.matches) {
    initializeMobileDetails();
  }
  _mqWide.addListener(function(mq) {
    if (sidebarList && mq.matches) {
      initializeMobileDetails();
    } else {
      Details.destroy('.details-heading');
      let aside = document.querySelector('#aside');
      if (aside) {
        aside.hidden = false;
      }
    }
  });

  // built for quote dropdowns in forum pages –
  // this is a global selector to always show dropdowns
  var forumDropdown = document.querySelector('[data-has-dropdown]');
  if ( forumDropdown ) {
    Details.init('[data-has-dropdown]');
  }

  collapsibleAccordionInit();
}

detailsInit();
